module.exports = __webpack_public_path__ + "static/img/logo.f68ea3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 585
// module chunks = 1